import { createAsyncThunk } from "@reduxjs/toolkit";
import { mapSubscriptionPlans } from "../Types/SiteMenuModel/MySubscription/SubscriptionPlan";
import { getMySubscriptionService, getPaymentHistoryService } from "../../Api/HeyTraderService/SiteMenuService";
import { mapSubscriptionHistorys } from "../Types/SiteMenuModel/MySubscription/SubscriptionHistory";

// get my subscriptions.
export const getMySubscription = createAsyncThunk('getMySubscription',async(_,{rejectWithValue})=>{
 try {  
    // api
         const response = await getMySubscriptionService();
         if (response.status) {
           return mapSubscriptionPlans(response.body['data']);
         } else {
           // If the API returns a failure status, return the error message
           return rejectWithValue(response.error);
         }
       } catch (error: any) {
         // Handle the case where the API call itself throws an error
         return rejectWithValue('Failed to fetch all projet details');
       }
});

// get payment history.
export const getPaymentHistory = createAsyncThunk('getPaymentHistory',async(_,{rejectWithValue})=>{
    try {  
       // api
            const response = await getPaymentHistoryService();
            if (response.status) {
              return mapSubscriptionHistorys(response.body['data']);
            } else {
              // If the API returns a failure status, return the error message
              return rejectWithValue(response.error);
            }
          } catch (error: any) {
            // Handle the case where the API call itself throws an error
            return rejectWithValue('Failed to fetch all projet details');
          }
   });
   